import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import { UserDataSourceService } from '../../services/user-data-source.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import { User } from '../../models/user';
import {
  DateTimeComponent,
  DetailsViewComponent,
  NoDataComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { RoleComponent } from '@web/shared/module/auth';
import { UserStatusComponent } from '../user-status/user-status.component';
import { AccountTypeComponent } from '../account-type/account-type.component';

@Component({
  selector: 'app-user-details',
  imports: [
    AsyncPipe,
    DetailsViewComponent,
    RoleComponent,
    UserStatusComponent,
    NoDataComponent,
    SpinnerFilledComponent,
    AccountTypeComponent,
    DateTimeComponent,
  ],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailsComponent {
  private readonly userDataSource = inject(UserDataSourceService);

  public readonly id = input.required<Guid>();

  protected readonly id$ = toObservable(this.id);
  protected readonly details$ = this.detailsSource();
  protected readonly isNotNil = isNotNil;

  private detailsSource(): Observable<User> {
    return this.id$.pipe(
      switchMap((id) => this.userDataSource.fetchDetailsById(id)),
    );
  }
}
